import classes from './password-input.module.css'

const PasswordInput = {
  classNames: {
    innerInput: classes.input,
  },
}

export const PasswordInputWrapper = {
  classNames: {
    label: classes['wrapper-label'],
  },
}

export default PasswordInput
